<script setup>
// O cartão de caixa conectada do kit Polaris falando a língua desta tela. O kit
// mostra o nome e o identificador separados (o número ou o endereço); aqui eles
// vêm de campos diferentes conforme o canal.
import { computed } from 'vue';
import { INBOX_TYPES } from 'dashboard/helper/inbox';
import InboxCard from 'dashboard/components-next/polaris/cards/InboxCard.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const emit = defineEmits(['action']);

const identifier = computed(() => {
  const { channel_type: channelType } = props.inbox;
  if (
    channelType === INBOX_TYPES.TWILIO ||
    channelType === INBOX_TYPES.WHATSAPP
  ) {
    return props.inbox.messaging_service_sid || props.inbox.phone_number || '';
  }
  if (channelType === INBOX_TYPES.EMAIL) return props.inbox.email || '';
  return '';
});
</script>

<template>
  <InboxCard
    :name="inbox.name"
    :channel="inbox.channel_type"
    :identifier="identifier"
    @action="({ action }) => emit('action', { action, id: inbox.id })"
  />
</template>
